<template>
  <div class="exp_edu" id="experience">
    <b-container class="exp_content">
      <b-row class="cover">
        <b-card :img-src="cover" img-alt="experience" img-top>
          <b-card-text>
            <h2>Experience</h2>
            <p>
              I’ve tried different things, which have helped me become versatile.
            </p>
          </b-card-text>
          <figure class="cover_icon">
            <b-img :src="coverIcon"></b-img>
          </figure>
        </b-card>
      </b-row>
      <b-row v-for="(info, i) in information" :key="i" class="exp_center_content">
        <b-col style="overflow: auto">
          <div class="content">
            <div class="logo">
              <figure>
                <b-img fluid :src="info.logo"></b-img>
              </figure>
            </div>
            <div class="content_body">
              <p style="margin-bottom: 0">
                <strong style="font-size: 20px">{{ info.title }}</strong> #{{
                  info.year
                }}
              </p>
              <p style="margin-bottom: 10px">
                <em><strong>@{{ info.company }}</strong></em>
              </p>
              <p>
                {{ info.body }}
                <b-icon icon="box-arrow-in-down-right" @click="showMoreText(i)" v-if="showExpandIcon(i)"
                  class="expand" />
              </p>
              <div>
                <div v-for="(e, ind) in info.expand" :key="ind">
                  <p v-if="isExpanded === i">{{ e }}</p>
                </div>
                <b-icon icon="box-arrow-in-up-left" @click="hideText(i)" v-if="isExpanded === i" class="hide" />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isExpanded: null,
      information: [
        {
          company: 'C2C Techhub',
          title: 'Product Owner & Frontend Developer',
          year: 'November 2020 - Present',
          logo: require('../assets/experience/c2c-techhub.jpeg'),
          body: 'Identify the product requirements, define user stories that meet those requirements, and create a product backlog',
          expand: [
            ' Prioritize the product backlog, ensuring tasks are assigned and completed according to the customer’s vision and goals.',
            'Monitor each phase of the product development lifecycle, from planning to maintenance.',
            'Follow the SCRUM development process',
            'Write, review, and maintain code to build functional, scalable, and user-friendly web applications using technologies such as React.js, Next.js, Redux-Saga, JavaScript, TypeScript, HTML, and CSS',
            'Ensure web applications perform well across platforms and browsers.',
            'Troubleshoot issues as soon as they are identified.',
            'Collaborate with developers, designers, and stakeholders.',
            'Follow SEO best practices',
          ],
        },
        {
          company: 'Freelancer',
          title: 'Freelance Full-stack Developer',
          year: 'April 2020 - Present',
          logo: require('../assets/experience/learn_coding.png'),
          body: 'Gained hands-on experience while learning programming independently by working as a freelance full-stack developer.',
          expand: [
            'Details about my projects and courses can be found in the Projects and Education sections',
          ],
        },
        {
          company: 'fetchEnglish',
          title: 'Founder',
          year: 'Sept 2019 - 2022',
          logo: require('../assets/experience/fetchenglish.png'),
          body: 'Founded FetchEnglish, an online learning platform offering courses for English learners.',
          expand: [
            'Built fetchEnglish.com after completing an online web development course on Udemy.',
          ],
        },
        {
          company: 'Viet Uc Language School',
          title: 'Teacher',
          year: '2012 - June 2020',
          logo: require('../assets/experience/VU.png'),
          body: 'Designed and delivered creative, practical lessons that were both educational and engaging.',
          expand: [
            'Helped many students achieve high scores in Cambridge and IELTS exams.',
            'Organized teacher training workshops and created tests and other reference materials.',
          ],
        },
        {
          company: 'Standard Chartered Bank',
          title: 'Loan officer (Retail Banking)',
          year: 'Mar - Sept 2011',
          logo: require('../assets/experience/SC.png'),
          body: 'Gave financial advice and assisted customers in preparing necessary documents relating to their loans.',
        },
      ],
      cover: require('../assets/experience/experience_cover.jpg'),
      coverIcon: require('../assets/experience/experience_icon.jpg'),
    };
  },
  methods: {
    showMoreText(i) {
      this.isExpanded = i;
    },
    hideText() {
      this.isExpanded = null;
    },
    showExpandIcon(i) {
      if (this.isExpanded === i) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
